export default {"src":"/_next/static/media/MET.e33ea9e5.svg","height":18,"width":18};